import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Trigger extraction and indexing for a profile document (Resume/CV).
 */
export const processProfileDocument = async (params: {
  profileId: string;
  storagePath: string;
  docType: 'resume' | 'cv';
}) => {
  const functions = getFunctions();
  const func = httpsCallable<{
    profileId: string;
    storagePath: string;
    docType: 'resume' | 'cv';
  }, {
    success: boolean;
    details: any;
    skills: string[];
    profileMeta: any;
    isIndexed: boolean;
  }>(functions, 'process_profile_document');
  
  const result = await func(params);
  return result.data;
};

/**
 * Automatically parameterize a Typst template using AI.
 */
export const parameterizeTypstTemplate = async (params: {
  source: string;
}) => {
  const functions = getFunctions();
  const func = httpsCallable<{
    source: string;
  }, {
    templatedSource: string;
  }>(functions, 'parameterize_typst_template');
  
  const result = await func(params);
  return result.data;
};
/**
 * Verify template compilation by rendering it with master data.
 */
export const verifyTemplateCompilation = async (params: {
  template: string;
  testData?: any;
}) => {
  const functions = getFunctions();
  const func = httpsCallable<{
    template: string;
    testData?: any;
  }, {
    success: boolean;
    rendered: string;
    dataUsed: any;
    error?: string;
  }>(functions, 'verify_template_compilation');
  
  const result = await func(params);
  return result.data;
};
